import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTH_PREFIX_PATH, UNAUTHENTICATED_ENTRY, REDIRECT_URL_KEY } from 'configs/AppConfig'

const ProtectedRoute = () => {
  const token = localStorage.getItem("auth_token");
  return token ? <Outlet /> : <Navigate to="/auth/login" replace />;
};


export default ProtectedRoute
